import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const DropDownStyled = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  ${mediaQuery[Screen.mobile]} {
    p {
      font-size: 20px;
    }
  }
`;

export const IconSection = styled.div`
  display: flex;
  flex-direction: row;

  svg {
    cursor: pointer;
  }
`;
